import { Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

declare var bootstrap: any;

@Component({
  selector: 'app-uiform-entry',
  templateUrl: './uiform-entry.component.html',
  styleUrls: ['./uiform-entry.component.scss'],
})
export class UiformEntryComponent extends BaseListCtl {
  /**
   * ID of the application to which this form belongs.
   */
  @Input() appId: number = 0;
  @Input() usecaseId: number | null = 0;
  @Input() uiformId: number | null = 0; // pass as a input

  public usecaseSchema: any = {};

  public attributeId: number = 0;

  public uiformDataList = [];

  public entryform: any = {
    data: { id: 0 }, //form data
  };

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    let _self = this;
    if (route.snapshot.paramMap.get('appId'))
      _self.appId = Number(route.snapshot.paramMap.get('appId'));

    if (route.snapshot.paramMap.get('usecaseId'))
      _self.usecaseId = Number(route.snapshot.paramMap.get('usecaseId'));

    if (route.snapshot.paramMap.get('uiformId'))
      _self.uiformId = Number(route.snapshot.paramMap.get('uiformId'));

    // overwrite from  route parameter
    if (_self.usecaseId) _self.form['userstoryId'] = _self.usecaseId;

    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.title = data.title;
    form.subtitle = data.subtitle;
    form.description = data.description;
    form.userstoryId = data.userstoryId;
    form.code = data.code;
    form.description = data.description;
    form.columns = data.columns;
    form.fields = data.fields;
    if (data.buttons) {
      form.buttons = data.buttons;
    }
  }

  override ngOnInit() {
    if (this.uiformId) this.get(this.uiformId);
    if (this.usecaseId) this.getUsecaseSchema();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['uiformId'] && !changes['uiformId'].isFirstChange()) {
      if (this.uiformId) this.get(this.uiformId); // Fetch data when uiformId changes
    }
    this.display();
  }

  display() {
    this.getUsecaseSchema();
  }

  getAttributeById(fieldId: number) {
    return this.attributeList.find(
      (attr: any) => attr.id === fieldId && attr['system'] != 1
    );
  }

  // Method to get the icon class based on the key
  getButtonIcon(buttonKey: string): string {
    const icons: { [key: string]: string } = {
      save: 'fas fa-save',
      cancel: 'fas fa-times',
      delete: 'bx bxs-trash',
      list: 'fas fa-list',
      new: 'fa fa-plus',
    };
    return icons[buttonKey] || '';
  }

  // Method to get the button label based on the key
  getButtonLabel(buttonKey: string): string {
    const labels: { [key: string]: string } = {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      list: 'List',
      new: 'New',
    };
    return labels[buttonKey] || buttonKey;
  }

  public attributeList: any = [];

  public getUsecaseSchema() {
    let _self = this;

    _self.locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        let url = `${property}/get/${_self.usecaseId}`;
        _self.locator.http.get(url, function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            return;
          }
          _self.usecaseSchema = res.result.data;
          _self.attributeId = _self.usecaseSchema['appId'];
          _self.getUiformDataList();
          _self.getUsecasePreloadData();
        });

        let attrUrl =
          _self.locator.config.get('endpoint.userstory.attributes') +
          '/list/' +
          _self.usecaseId;
        _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
          _self.attributeList = res.result.data;
        });
      });
  }

  /**
   * Get API base URL
   * @returns
   */
  getAPIBaseUrl(suburl?: string) {
    let _self = this;
    let updatedName = _self.usecaseSchema['collectionName'].replace(/\./g, '/');
    let url = _self.locator.config.get('endpoint.api.v1') + '/' + updatedName;
    if (suburl) {
      url += '/' + suburl;
    }
    return url;
  }

  /**
   * Get usecase preload data
   */
  public getUsecasePreloadData() {
    let _self = this;
    let url = _self.getAPIBaseUrl('preload');

    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.form['preload'] = res.result;
    });
  }

  public onChange(e: any, val: any) {
    let _self = this;
    let l = _self.form.preload[e['primaryUsecase']];
    let col = e['depAttribute'];
    for (let i = 0; i < l.length; i++) {
      if (l[i]['id'] == val.target.value) {
        _self.entryform.data[col] = l[i]['name'];
        //alert(_self.form.data[col]);
      }
    }
    //alert(val.target.value);
  }

  public getInputType(t: string) {
    if (t === 'date') {
      return t;
    } else if (t === 'number' || t === 'decimal') {
      return 'number';
    }
    if (t === 'text') {
      return 'text';
    }
    if (t === 'date') {
      return t;
    }
    if (t === 'time') {
      return t;
    }
    if (t === 'file') {
      return t;
    } else {
      return 'text';
    }
  }

  public getInputError(name: string) {
    let _self = this;
    let errMsg = '';
    let ie = _self.form['inputerror'];
    if (ie && ie[name]) {
      errMsg = ie[name];
    }
    return errMsg;
  }

  /**
   * Upload Image
   * @param event
   */
  /**
   *
   * @param event
   * @param code
   * @param imageId
   */
  public onFileChanged(event: any, code: string, imageId: any) {
    const fileObj = event.target.files[0];
    var _self = this;
    if (imageId === null || imageId === undefined) {
      imageId = 0;
      alert(imageId);
    }
    let url = _self.getAPIBaseUrl(
      'doc/' + _self.form.data['id'] + '/' + imageId + '/' + code
    );
    var param = {
      id: this.form.data.id,
    };
    this.locator.http.postMutipart(
      url,
      param,
      fileObj,
      function (res: any, error: any) {
        if (error) {
          alert(error);
          return;
        }
        _self.form.error = !res.success;
        _self.form.message = res.result.message;
        if (res.success) {
          _self.form.message = 'file is uploaded';
          _self.form.data[code] = res.result.data.imageId;
          _self.changeDoc();
          _self.getDocThumbnail(_self.form.data[code]);
        }
      }
    );
  }

  urlRewrite(endpoint: string) {
    let keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
    let sid = localStorage.getItem(keySuffix + 'sessionId');
    if (!sid) {
      sid = '0';
    }
    endpoint = endpoint + ';jsessionid=' + sid;
    return endpoint;
  }

  public saveUiformData() {
    let _self = this;
    let url = _self.urlRewrite(_self.getAPIBaseUrl('save'));
    _self.locator.http.post(
      url,
      _self.entryform['data'],
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.entryform['error'] = !res.success;
        _self.entryform['message'] = res.message;
        if (res.result?.inputerror?.key) {
          _self.entryform['message'] = res.result['inputerror']['key'];
        } else {
        _self.entryform['inputerror'] = res.result['inputerror'];
        }
        if (res.success) {
          _self.entryform['data']['id'] = res.result['data']['id'];
          _self.getUiformDataList();
        }
      }
    );
  }

  /**
   * Get usecase record by primary key
   * @param id
   */
  public getUiformData(id: number) {
    let _self = this;
    if (!(id > 0)) {
      return;
    }

    let url = _self.getAPIBaseUrl('get') + '/' + id;
    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.entryform['data'] = res.result['data'];
    });
    _self.getUsecasePreloadData();
  }

  /**
   * Delete a record
   *
   * @param id
   * @returns
   */
  public deleteUiformData(id: number) {
    let _self = this;
    if (!(id > 0)) {
      return;
    }

    let flag = confirm('Are you sure');
    if (!flag) {
      return;
    }

    let url = _self.getAPIBaseUrl('delete') + '/' + id;

    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.entryform.error = !res.success;
      _self.entryform.message = res.message;
      _self.entryform['inputerror'] = res.result['inputerror'];
      if (res.success) {
        _self.getUiformDataList();
        _self.getUsecasePreloadData();
      }
    });
  }

  /**
   * get usecase records list
   */
  public getUiformDataList() {
    let _self = this;
    let url = _self.getAPIBaseUrl() + '/search';

    // let filter = {
    //   'uiformId': this.form.data['id']
    // }

    _self.locator.http.post(url, {}, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.uiformDataList = res.result['data'];
    });
  }

  public getString(val: any, type: string) {
    if (val) {
      if (type === 'object' || type === 'list') {
        val = JSON.stringify(val);
      }
      return val;
    } else {
      return '';
    }
  }

  override clearMessage(obj: any) {
    obj['error'] = false;
    obj['message'] = null;
  }

  resetUiformData() {
    let _self = this;
    _self.entryform['data'] = {};
  }

  onSave() {
    //this.entryform.data['uiformId'] = this.form.data['id'];
    this.saveUiformData();
  }

  onCancel() {
    // nothing do
  }

  onList() {
    // nothing do
    // go to list page
  }

  onDelete() {
    // nothing do
    // go to list page
  }

  onNew() {
    this.resetUiformData();
  }

  fieldButtonSubmit(button: string) {
    let _self = this;
    if (button === 'save') {
      _self.onSave();
    }
    if (button === 'cancel') {
      _self.onCancel();
    }

    if (button === 'list') {
      _self.onList();
    }

    if (button === 'delete') {
      _self.onDelete();
    }

    if (button === 'new') {
      _self.onNew();
    }
  }

  changeTab(targetId: string) {
    const targetTab = document.querySelector(`button[id="${targetId}"]`);
    if (targetTab) {
      const bootstrapTab = new bootstrap.Tab(targetTab); // Initialize Bootstrap tab
      bootstrapTab.show(); // Show the target tab
    }
  }

  ngAfterViewInit() {
    this.initializeTabListeners();
  }

  initializeTabListeners() {
    const tabLinks = document.querySelectorAll(
      '.nav-link[data-bs-toggle="pill"]'
    );
    tabLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        this.handleTabChange(event);
      });
    });
  }

  handleTabChange(event: Event) {
    const target = (event.currentTarget as HTMLElement).getAttribute(
      'data-bs-target'
    );
  }
}
